
import { api } from "./axios";

export const assetsApi = {

    create: (artistId: string, formData: FormData) =>
        api.post(`/artists/create-assets/${artistId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            timeout: 60000,
        }),
    createWithoutArtist: (formData: FormData) =>
        api.post(`/pitches/upload-pitch-images`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            timeout: 60000,
        }),
    getByArtistId: (artistId: string, searchParams?: { title?: string; category?: string }) => {
        const url = `/artists/get-assets/${artistId}`;
        return api.get(url, { params: searchParams });
    },
    update: (artistId: string, index: number, imageTitle: string) =>
        api.put(`/artists/update-image-title/${artistId}/${index}`, { imageTitle: imageTitle }),
    // The backend identifies the asset to delete by its URL (in the request body), not by index.
    delete: (artistId: string, url: string) =>
        api.delete(`/artists/delete-asset/${artistId}`, { data: { url } }),
};
